// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
// Locale
import messages from '../../locale/messages';
// Style
import {
  Button,
  Grid,
  Row,
  Col
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ExistingPage.css';
import bt from '../../components/commonStyle.css';

// Component
import Loader from '../Loader';

//Images
import BgImage from '../../../public/SiteImages/listingBg.png';
import defaultPic from '../../../images/banner/939b39d1472ce0b492d8cce42ff66f5c.png';

// Redux action
import { ManagePublishStatus } from '../../actions/Listing/ManagePublishStatus';
import history from '../../core/history';
class ExistingPage1 extends Component {
  static propTypes = {
    listingSteps: PropTypes.shape({
      step1: PropTypes.string.isRequired,
      step2: PropTypes.string.isRequired,
      step3: PropTypes.string.isRequired,
      listing: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isReady: PropTypes.bool.isRequired,
        isPublished: PropTypes.bool.isRequired
      }),
      user: PropTypes.shape({
        userBanStatus: PropTypes.number,
      }),
    }),
    nextPage: PropTypes.any.isRequired,
    stepsLoading: PropTypes.bool,
    ManagePublishStatus: PropTypes.any.isRequired,
    publishListLoading: PropTypes.bool,
  };
  static defaultProps = {
    listingSteps: {
      step1: "inactive",
      step2: "inactive",
      step3: "inactive",
      step4: "active",
      listing: {
        id: 0,
        isReady: false,
        isPublished: false
      },
      user: {
        userBanStatus: 0,
      }
    },
    photosCount: 0,
    stepsLoading: false,
    publishListLoading: false
  };
  render() {
    const { nextPage, listingSteps, photosCount, stepsLoading, account, publishListLoading } = this.props;
    const { formatMessage } = this.props.intl;
    if (stepsLoading) {
      return <Loader type={"text"} />
    }
    const { listingSteps: { listing: { id, isReady, isPublished, user } } } = this.props;

    let userDelete = user && user.userDeletedAt;
    let isShowButton = false, stepOneCircle = false, stepTwoCircle = false, stepThreeCircle = false;
    let stepFour = false;

    if (!userDelete) {
      isShowButton = true;
    } else {
      isShowButton = false;
    }

    let userBanStatusValue;
    if (user) {
      const { listingSteps: { listing: { user: { userBanStatus } } } } = this.props;
      userBanStatusValue = userBanStatus;
    }
    const { listingSteps: { step1, step2, step3, step4 } } = this.props;
    const { ManagePublishStatus } = this.props;
    let isPhotoAvailable = false;
    if (photosCount > 0) {
      isPhotoAvailable = true;
    }

    if (step1 == 'completed') {
      stepOneCircle = true;
    }
    if (step2 == 'completed' && isPhotoAvailable) {
      stepTwoCircle = true;
    }
    if (step4 == 'completed') {
      stepThreeCircle = true;
    }

    if (step3 == "active") {
      stepFour = true;
    }

    if (step3 == "completed" && step4 == "active") {
      stepFour = true;
    }

    return (
      <div className={s.positionRelative}>
        {/* <div className={s.bgImage} /> */}
        <div className={s.bgImage} style={{ backgroundImage: `url(${BgImage})` }} />
        <div className={cx(s.mainSectionPadding, 'noPaddingBottom')}>
          <Grid className={s.landingContainer}>
            <Row>
              <h2 className={cx(bt.listingTitleText, s.titleText)}><FormattedMessage {...messages.listingoverview} /></h2>
              <Col xs={12} sm={7} md={7} lg={6}>
                <div>
                  <div className={cx(s.positionRelative)}>
                    <div className={cx(s.contentWidth, s.paddingBottom, s.mainSection)}>
                      <div className={cx(s.contentSection, s.circle, 'exittingCircle', { [s.circleSuccess]: stepOneCircle })}>
                        <h3 className={cx(s.step)}><span><FormattedMessage {...messages.step1HeadingNew} /></span></h3>
                        <p className={cx(s.landingTitleStep, s.space3)}><span><FormattedMessage {...messages.step1HeadingContent} /></span></p>
                        {
                          step1 == "active" && <Button className={cx(s.button, bt.listbtnPrimary)} onClick={() => nextPage('map')}>
                            <FormattedMessage {...messages.start} />
                          </Button>
                        }
                        {
                          step1 == "completed" && <a href="javascript:void(0);" className={cx(bt.listbtnPrimary, s.displayInlineBlock)} onClick={() => nextPage('room')}>
                            <FormattedMessage {...messages.change} />
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className={cx(s.positionRelative)}>
                    <div className={cx(s.contentWidth, s.paddingBottom, s.mainSection)}>
                      <div className={cx(s.contentSection, s.circle, 'exittingCircle', { [s.circleSuccess]: stepTwoCircle })}>
                        <h3 className={s.step}><span><FormattedMessage {...messages.step2Heading} /></span></h3>
                        <p className={cx(s.landingTitleStep, s.space3)}><span><FormattedMessage {...messages.step2HeadingContent} /></span></p>
                        {
                          step2 == "active" && <Button className={cx(s.button, bt.listbtnPrimary)} onClick={() => nextPage('photos')}>
                            <FormattedMessage {...messages.start} />
                          </Button>
                        }
                        {
                          step2 == "completed" && !isPhotoAvailable && <Button className={cx(s.button, bt.listbtnPrimary)} onClick={() => nextPage('photos')}>
                            <FormattedMessage {...messages.start} />
                          </Button>
                        }
                        {
                          step2 == "completed" && isPhotoAvailable && <a href="javascript:void(0);" className={cx(bt.listbtnPrimary, s.displayInlineBlock)} onClick={() => nextPage('photos')}>
                            <FormattedMessage {...messages.change} />
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className={cx(s.positionRelative)}>
                    <div className={cx(s.contentWidth, s.mainSection)}>
                      <div className={cx(s.contentSection, s.circle, 'exittingCircle', { [s.circleSuccess]: stepThreeCircle })}>
                        <h3 className={s.step}><span><FormattedMessage {...messages.step3Heading} /></span></h3>
                        <p className={cx(s.landingTitleStep, s.space3)}><span><FormattedMessage {...messages.step3HeadingContent} /></span></p>
                        {
                          stepFour == true && <Button className={cx(s.button, bt.listbtnPrimary)} onClick={() => nextPage('house-rules')}>
                            <FormattedMessage {...messages.start} />
                          </Button>
                        }
                        {
                          step4 == "completed" && <a href="javascript:void(0);" className={cx(bt.listbtnPrimary, s.displayInlineBlock)} onClick={() => nextPage('house-rules')}>
                            <FormattedMessage {...messages.change} />
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={5} md={5} lg={6}>
                <div>
                  <div>
                    <img src={defaultPic} className={s.imageSection} />
                  </div>
                </div>
              </Col>
            </Row>
            <div>
              {
                !isShowButton &&
                <Col xs={12} sm={12} md={12} lg={12} >
                  <h3 className={s.spaceTop1}>
                    <FormattedMessage {...messages.listDeleted} />
                  </h3>
                </Col>
              }
              {
                listingSteps && isReady && !isPublished && !userBanStatusValue && isShowButton && <div>
                  {/* <h3 className={s.spaceTop1}>
                      <FormattedMessage {...messages.readyToPublish} />
                    </h3> */}
                  <Col xs={12} sm={6} md={6} lg={6} className={cx(s.publishBtnPadding)}>
                    <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(s.previewLink, 'prviewLinkAR')}>
                      <FormattedMessage {...messages.previewListing} />
                    </a>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6} className={cx(s.publishBtnRight, s.publishBtnPadding)}>
                    <div className={s.displayInline}>
                      <Loader
                        type={"button"}
                        className={cx(s.button, bt.continueBtnListing, s.pulishBtnWidth)}
                        handleClick={() => ManagePublishStatus(id, 'publish')}
                        // disabled={disabled}
                        show={publishListLoading}
                        label={formatMessage(messages.publishNow)}
                      />
                    </div>
                  </Col>
                </div>
              }
              {
                listingSteps && isReady && isPublished && !userBanStatusValue && isShowButton && <div>
                  {/* <h3 className={s.spaceTop1}>
                      <FormattedMessage {...messages.listingPublished} />
                    </h3> */}
                  <Col xs={12} sm={6} md={6} lg={6} className={s.publishBtnPadding}>
                    <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(s.previewLink, 'prviewLinkAR')}>
                      <FormattedMessage {...messages.previewListing} />
                    </a>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6} className={cx(s.publishBtnRight, s.publishBtnPadding)}>
                    <div className={s.displayInline}>
                      <Loader
                        type={"button"}
                        className={cx(s.button, bt.continueBtnListing, s.pulishBtnWidth)}
                        handleClick={() => ManagePublishStatus(id, 'unPublish')}
                        // disabled={disabled}
                        show={publishListLoading}
                        label={formatMessage(messages.unPublishNow)}
                      />
                    </div>
                  </Col>
                </div>
              }
              {
                userBanStatusValue == true && isShowButton && <Col xs={12} sm={12} md={12} lg={12} className={s.spaceTop3}>
                  <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(s.previewLinkUserBan)}>
                    <FormattedMessage {...messages.previewListing} />
                  </a>
                </Col>
              }
              {
                <Col xs={12} sm={12} md={12} lg={12} className={cx('visible-xs', s.spaceTop3, s.returnToListingPadding)}>
                  <Button onClick={() => history.push('/rooms')} className={cx(s.previewLink, 'prviewLinkAR')}>{formatMessage(messages.returnToListing)}</Button>
                </Col>
              }
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}
const mapState = (state) => ({
  listingSteps: state.location.listingSteps,
  stepsLoading: state.location.stepsLoading,
  account: state.account.data,
  publishListLoading: state.location.publishListLoading,
});
const mapDispatch = {
  ManagePublishStatus
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ExistingPage1)));


// WEBPACK FOOTER //
// src/components/ListPlaceStep1/ExistingPage1.js